import { findPassword, findPasswordUpdate } from '@/api';

const namespaced = true;

const state = {
	updateUserInfo: {},
};

const getters = {
	updateUserInfo(state) {
		return state.updateUserInfo;
	},
};

const mutations = {
	getUserInfo(state, userInfo) {
		state.updateUserInfo = userInfo || {};
	},
};

const actions = {
	getUserInfo({ commit }, payload) {
		return findPassword(payload)
			.then(response => {
				commit('getUserInfo', response.data.user);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	updateUserPassword(context, payload) {
		return findPasswordUpdate(payload)
			.then(response => {
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
